import { put, takeLatest, call, all } from 'redux-saga/effects';
import types from '../../types';
import api from '../../../services/api';
import notification from '../../../services/notification';

function* getHistory({ payload }) {
  try {
    const { data, status } = yield call(api.profile.getTradeHistory, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_MARGIN_HISTORY_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_MARGIN_HISTORY_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* getRepayment({ payload }) {
  try {
    const { data, status } = yield call(api.profile.getRepayments, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_MARGIN_REPAYMENT_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_MARGIN_REPAYMENT_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

function* getTransfers({ payload }) {
  try {
    const { data, status } = yield call(api.profile.getTransfers, payload);
    if (status < 200 || status >= 300) throw new Error('Something went wrong');
    yield put({ type: types.GET_MARGIN_TRANSFERS_SUCCESS, payload: data });
  } catch (error) {
    yield put({ type: types.GET_MARGIN_TRANSFERS_FAILURE });
    if (error?.response?.status === 401) return;
    notification({ type: 'error', message: 'Something went wrong' });
  }
}

export function* margin() {
  yield all([
    yield takeLatest(types.GET_MARGIN_HISTORY_START, getHistory),
    yield takeLatest(types.GET_MARGIN_REPAYMENT_START, getRepayment),
    yield takeLatest(types.GET_MARGIN_TRANSFERS_START, getTransfers),
  ]);
}
